import Dashboard, { DashboardSection } from '@g17eco/molecules/dashboard';
import { BenchmarkingNavigation } from './BenchmarkingNavigation';

interface BenchmarkingTemplateProps {
  children: JSX.Element;
}

export const BenchmarkingTemplate = (props: BenchmarkingTemplateProps) => {
  return (
    <Dashboard className='benchmarking__container'>
      <DashboardSection>
        <BenchmarkingNavigation />
        {props.children}
      </DashboardSection>
    </Dashboard>
  );
};
